import apiClient from './api_client_requests';

export default async (payload) => {
    let result = await apiClient.apiMethod({
        method: 'Feedback',
        args: {
            ...payload,
        },
    });

    return {
        success: result?.success,
        isError: result?.isError,
        error: result?.error ?? '',
    };
};

/*
*OK
{
    "feedback": {
        "message": "Thank you. Your email has been sent.\\r\\n\\r\\nA player service representative will review your feedback and respond as necessary to the email address you provided.",
        "html_message": "<p><strong>Thank you. Your email has been sent.<\/strong><\/p><p>A player service representative will review your feedback and respond as necessary to the email address you provided.<\/p>"
    },
    "response": {
        "code": 200
    }
}

!ERROR:

{
    "response": {
        "code": 0,
        "message": "Please enter your name.",
        "details": 401
    }
}
*/
